function checkCarouselMobile() {
	if (!App.isSSR) {
		const carouselElement = $("div.widget-inner.carousel.slide");
		// const carouselElement = $("div[id^='image-carousel_'][data-mobile-scroll='false']");

		if (
			carouselElement.length &&
			window.innerWidth <= 991 &&
			carouselElement.first().attr("data-mobile-scroll") === "false"
		) {
			setTimeout(function() {
				carouselElement.carousel("pause");
			}, 2500);
		}
	}
}



if (App.Eros.Config.general.benchmarkJS) console.time("App.eros.common.carouselMobileCheck: checkCarouselMobile"); // eslint-disable-line no-console
checkCarouselMobile();
if (App.Eros.Config.general.benchmarkJS) console.timeEnd("App.eros.common.carouselMobileCheck: checkCarouselMobile"); // eslint-disable-line no-console